<script lang="ts" setup>


const title = '事業内容'
const desc = `世界とつながる、新しい調達のカタチ。<br/>
X＆R GLOBALが、あなたのビジネスを次のステージへ。`


const cards = [
  {
    title: 'B2B越境調達サービス事業',
    image: 'https://static-jp.theckb.com/static-asset/xr/service_1.png',
    text: 'CKB Choice は、日本および海外の小売事業様向けに開発したシンプルかつ効率的な次世代のB2B調達プラットフォームです。',
    link: {
      href: 'https://s.theckb.com/choice',
      label: 'CKB Choice公式サイトへ'
    },
    md: `
      - 韓国・中国を中心に、他類似サイトでは手に入らない商品を仕入れ可能に
      - 小ロット＆オールイン価格（関税・送料込み）により低リスクかつ透明性の高い取引を実現
      - AIによる商品レコメンドで、最適な仕入れをサポート
      <br/>
      中間プロセスを極力削減することで、調達の効率化を推進します。
    `
  },
  {
    title: 'ブランドの海外市場進出支援事業',
    image: 'https://static-jp.theckb.com/static-asset/xr/service_2.png',
    text: '海外ブランドの日本展開、日本ブランドの海外進出を支援。市場分析、マーケティング、店舗運営まで、最適なパートナーと連携しワンストップで提供します。',
    md: `
      # 海外ブランド向け
      海外ブランドの日本市場進出を支援するため、市場分析、マーケティング施策の立案・実行、オンライン・オフライン店舗の代理運営まで、パートナー企業と連携しワンストップで提供します。
      <br/>
      # 日本ブランド向け
      市場エリアによって最適なパートナーをマッチング、きめ細やかなサポートで日本ブランド様の海外進出をトータルサポートします。
    `
  },
  {
    title: '貿易・物流ソリューション事業',
    image: 'https://static-jp.theckb.com/static-asset/xr/service_3.png',
    text: '伊藤忠商事のグローバルネットワークとSNIFF社の物流リソースを活用し、グローバルな物流ソリューションを提供します。',
    md: `
      - 倉庫管理 & フルフィルメント（在庫最適化）
      - 輸送 & 配送管理（スムーズな国内外物流）
      - 貿易サポート（通関業務 & 書類手配）
      <br/>
      仕入れから配送まで、一貫した物流サポートでクライアントの成長を支えます。
    `
  }
]

const cardTitles = cards.map(v => v.title)

const index = ref(0)

// 监听滚轮
const el = ref<HTMLElement>()
const handleWheel = useThrottleFn((e: WheelEvent) => {
  if (e.deltaX === 0 || e.deltaY !== 0) return e.preventDefault()
  const step = e.deltaX > 0 ? 1 : -1
  const next = index.value + step
  if (next >= 0 && next < cards.length) {
    e.preventDefault()
    index.value = next
  }
}, 1000)

onMounted(() => {
  useDevice().isH5 || el.value?.addEventListener('wheel', handleWheel)
})
onUnmounted(() => {
  el.value?.removeEventListener('wheel', handleWheel)
})
</script>

<template>
  <div id="service" ref="el">
    <ADevice>
      <template #h5>
        <MCol class=" py-12 gap-6">
          <MContainer>
            <MText size="h1" placement="left" class="font-black mb-2">{{ title }}</MText>
            <MText size="lg" placement="left" class=" pr-2 text-[#000000A6]" v-html="desc"></MText>
          </MContainer>
          <ASwipeCross v-model="index" :items="cards" class=" gap-6">
            <!-- <template #title="{ item }">
              <MText class="font-black">{{ item.title }}</MText>
            </template> -->
            <template #content="{ item }">
              <MContainer>
                <MCol class=" gap-6">
                  <div>
                    <img :src="item.image" alt="">
                  </div>
                  <MCol class=" gap-2">
                    <MText class="font-black" size="h3" placement="left">{{ item.title }}</MText>
                    <MText size="lg" placement="left" v-html="item.text"></MText>
                  </MCol>
                  <MButtonLinkP1 v-if="item.link" class=" w-full">
                    <ALink :to="item.link.href">{{ item.link.label }}</ALink>
                  </MButtonLinkP1>
                  <AMd :md="item.md" class=" text-left text-[16px] leading-[24px] text-[#000000E0]"></AMd>
                </MCol>
              </MContainer>
            </template>
          </ASwipeCross>
        </MCol>
      </template>
      <template #pc>
        <AContainer class=" px-[160px] py-[72px]">
          <MRow class=" justify-between">
            <div class=" w-[544px] self-start">
              <ASwipe v-model="index" :items="cards" class=" w-full shadow-md">
                <template #item="{ item }">
                  <img :src="item.image" alt="">
                </template>
              </ASwipe>
              <MRow class=" mt-[57px] gap-[32px]">
                <AText size="h1" class=" flex-9 self-start">{{ title }}</AText>
                <MText size="lg" placement="left" class=" py-[54px] flex-1 text-[#000000A6]" v-html="desc"></MText>
              </MRow>
            </div>
            <MCol class=" w-[531px] gap-[84px]">
              <ASwipe v-model="index" :items="cards" class=" w-full">
                <template #item="{ item }">
                  <MCol class=" gap-[64px]">
                    <div>
                      <MText size="h1" class=" mb-[8px]" placement="left">{{ item.title }}</MText>
                      <MText size="lg" class=" h-[72px]" placement="left">{{ item.text }}</MText>
                    </div>
                    <MCol class=" self-end gap-[8px]">
                      <MText v-for="(v, i) in cardTitles" placement="left" class=" font-[900] cursor-pointer"
                        @click="index = i" :class="i === index ? ' text-[#000000E0]' : 'text-[#00000040]'">{{ v }}
                      </MText>
                    </MCol>
                    <MRow class=" !items-end justify-end">
                      <MButtonLinkP1 v-if="item.link" class=" w-[320px] px-[32px] py-[16px]">
                        <ALink :to="item.link.href">{{ item.link.label }}</ALink>
                      </MButtonLinkP1>
                    </MRow>
                  </MCol>
                </template>
                <template #outer>
                  <MRow class=" gap-[16px] absolute z-10 bottom-0">
                    <span v-for="(v, i) in cards" class=" h-[12px] w-[12px] rounded-full cursor-pointer transition"
                      @click="index = i" :class="i === index ? ' bg-[#000000E0]' : 'bg-[#00000040]'"></span>
                  </MRow>
                </template>
              </ASwipe>
              <ASwipe v-model="index" :items="cards" class=" w-full">
                <template #item="{ item }">
                  <AMd :md="item.md" class=" text-left pl-[20px] text-[16px] leading-[24px] text-[#000000E0]"></AMd>
                </template>
              </ASwipe>
            </MCol>
          </MRow>
        </AContainer>
      </template>
    </ADevice>
  </div>
</template>

<style lang="scss" scoped></style>
